document.addEventListener("DOMContentLoaded", function () {
  const STORAGE_KEY = "thread11_sizes";
function normalizeBraSize(size) {
  return String(size || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "");
}
  const modal =
    document.getElementById("FindSizeModal");
  const openBtn =
    document.getElementById("FindSizeOpen");
  const closeBtn =
    document.getElementById("FindSizeClose");
  const overlay =
    document.getElementById("FindSizeOverlay");
  const progress =
    document.getElementById("FindSizeProgress");
  const result =
    document.getElementById("RecommendedSize");
  const shopBtn =
    document.getElementById("ShopMySize");
  const retakeBtn =
    document.getElementById("RetakeQuiz");
  const steps =
    Array.from(
      document.querySelectorAll(".find-size-step")
    );
  let currentStep = 0;
  let visibleSteps = [];
  let answers = {
    category: "",
    size: "",
    band: "",
    cup: "",
    fit: "",
    style: ""
  };
  function getSavedSizes() {
    try {
      return JSON.parse(
        localStorage.getItem(STORAGE_KEY) || "{}"
      );
    } catch (error) {
      return {};
    }
  }
  function saveSize(category, size) {
    const saved = getSavedSizes();
    saved[category] = size;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(saved)
    );
  }
  function getProductCategory() {
    const productType =
      (
        window.thread11ProductCategory ||
        ""
      ).toLowerCase();
    const collection =
      (
        window.thread11ProductCollection ||
        ""
      ).toLowerCase();
    const value =
      productType + " " + collection;
    if (value.includes("bra")) {
      return "bra";
    }
    if (
      value.includes("brief") ||
      value.includes("panty") ||
      value.includes("panties")
    ) {
      return "briefs";
    }
    if (value.includes("lingerie")) {
      return "lingerie";
    }
    if (value.includes("shapewear")) {
      return "shapewear";
    }
    if (
      value.includes("nightwear") ||
      value.includes("night wear") ||
      value.includes("sleepwear")
    ) {
      return "nightwear";
    }
     if (
    value.includes("exotic") ||
    value.includes("exotic wear") ||
    value.includes("exotic-wear")
  ) {
    return "exotic";
  }
  if (
  value.includes("silk") ||
  value.includes("silk wear") ||
  value.includes("silk-dresses")
) {
  return "silk";
}
  }
  function openModal() {
    if (!modal) return;
    modal.classList.add("active");
    document.body.classList.add(
      "find-size-open"
    );
    resetQuiz();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove("active");
    document.body.classList.remove(
      "find-size-open"
    );
  }
  if (openBtn) {
    openBtn.addEventListener(
      "click",
      openModal
    );
  }
  if (closeBtn) {
    closeBtn.addEventListener(
      "click",
      closeModal
    );
  }
  if (overlay) {
    overlay.addEventListener(
      "click",
      closeModal
    );
  }
  function resetQuiz() {
    answers = {
      category: "",
      size: "",
      band: "",
      cup: "",
      fit: "",
      style: ""
    };
    currentStep = 0;
    document
      .querySelectorAll(".size-option")
      .forEach(function (button) {
        button.classList.remove("active");
      });
    visibleSteps = [];
    buildQuiz();
  }
  function buildQuiz() {

    visibleSteps = [];
    const categoryStep =
      steps.find(function (step) {
        return step.dataset.step === "0";
      });
    if (categoryStep) {
      visibleSteps.push(categoryStep);
    }
    if (answers.category === "bra") {

      steps.forEach(function (step) {

        if (
          step.dataset.question === "bra"
        ) {

          visibleSteps.push(step);

        }

      });

    }
    else if (
      answers.category &&
      answers.category !== "bra"
    ) {
      steps.forEach(function (step) {
        if (
          step.dataset.question === "general"
        ) {
          visibleSteps.push(step);
        }
      });
    }
    const resultStep =
      steps.find(function (step) {

        return step.dataset.step === "result";
      });
    if (resultStep) {

      visibleSteps.push(resultStep);

    }
    currentStep = 0;

    showStep(currentStep);

  }
  function showStep(index) {

    if (!visibleSteps.length) {
      return;
    }
    visibleSteps.forEach(
      function (step) {

        step.classList.remove("active");
      }
    );
    const activeStep =
      visibleSteps[index];
    if (!activeStep) {
      return;
    }
    activeStep.classList.add("active");
    if (progress) {

      const questionSteps =
        visibleSteps.filter(function (step) {

          return (
            step.dataset.step !== "0" &&
            step.dataset.step !== "result"
          );
        });
      const questionIndex =
        Math.max(
          0,
          questionSteps.indexOf(activeStep)
        );
      let percentage;


      if (
        activeStep.dataset.step === "result"
      ) {

        percentage = 100;

      }

      else {

        percentage =
          ((questionIndex + 1) /
            questionSteps.length) *
          100;

      }


      progress.style.width =
        percentage + "%";

    }

  }
  document
    .querySelectorAll("[data-category]")
    .forEach(function (button) {

      button.addEventListener(
        "click",
        function () {

          answers.category =
            this.dataset.category;


          document
            .querySelectorAll("[data-category]")
            .forEach(function (btn) {

              btn.classList.remove("active");

            });


          this.classList.add("active");

          buildQuiz();

          currentStep = 1;

          showStep(currentStep);

        }
      );

    });


  document
    .querySelectorAll(
      ".size-option:not([data-category])"
    )
    .forEach(function (button) {

      button.addEventListener(
        "click",
        function () {

          const step =
            this.closest(".find-size-step");


          if (!step) {
            return;
          }


          const value =
            this.dataset.value;
          step
            .querySelectorAll(".size-option")
            .forEach(function (btn) {

              btn.classList.remove("active");

            });


          this.classList.add("active");


          if (answers.category === "bra") {

            const braSteps =
              visibleSteps.filter(
                function (item) {

                  return (
                    item.dataset.question === "bra"
                  );

                }
              );


            const questionIndex =
              braSteps.indexOf(step);
            if (questionIndex === 0) {

              answers.size = value;

            }

            else if (questionIndex === 1) {

              answers.band = value;

            }

            else if (questionIndex === 2) {

              answers.cup = value;

            }

            else if (questionIndex === 3) {

              answers.style = value;

            }

          }

          else {

            const generalSteps =
              visibleSteps.filter(
                function (item) {

                  return (
                    item.dataset.question ===
                    "general"
                  );

                }
              );
            const questionIndex =
              generalSteps.indexOf(step);
            if (questionIndex === 0) {

              answers.size = value;

            }

            else if (questionIndex === 1) {

              answers.fit = value;

            }

          }

          setTimeout(
            function () {

              const nextStep =
                currentStep + 1;

              if (
                nextStep >=
                visibleSteps.length - 1
              ) {

                calculateSize();

                return;

              }


              currentStep =
                nextStep;


              showStep(currentStep);

            },
            200
          );

        }
      );

    });

  function calculateBraSize() {

    let original =
       normalizeBraSize(answers.size || "34B");
if (
    original === "FREESIZE" ||
    original === "FREE SIZE"
  ) {
    return "Free Size";
  }

    let band =
      parseInt(original, 10);


    let cup =
      original
        .replace(/[0-9]/g, "")
        .toUpperCase();

    if (answers.band === "tight") {

      band += 2;

    }
    if (answers.band === "loose") {

      band -= 2;
    }
    const cups = [
      "A",
      "B",
      "C",
      "D",
      "DD"
    ];
    let cupIndex =
      cups.indexOf(cup);


    if (cupIndex < 0) {

      cupIndex = 1;

    }
    if (
      answers.cup === "overflow"
    ) {

      cupIndex++;

    }
    if (
      answers.cup === "gap"
    ) {
      cupIndex--;
    }
    cupIndex =
      Math.max(
        0,
        Math.min(
          cups.length - 1,
          cupIndex
        )
      );
    band =
      Math.max(
        28,
        Math.min(
          44,
          band
        )
      );
    return (
      band +
      cups[cupIndex]
    );

  }
  function calculateGeneralSize() {
    const sizes = [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL",
      "7XL"
    ];
    let size =
      (
        answers.size ||
        "M"
      ).trim();
if (size.toLowerCase() === "free size") {
    return "Free Size";
  }

  size = size.toUpperCase();

    let index =
      sizes.indexOf(size);


    if (index === -1) {

      index = 2;

    }
    if (
      answers.fit === "snug"
    ) {

      index--;

    }
    if (
      answers.fit === "relaxed"
    ) {
      index++;
    }
    index =
      Math.max(
        0,
        Math.min(
          sizes.length - 1,
          index
        )
      );
    return sizes[index];
  }
  function calculateSize() {
    let finalSize;
    if (
      answers.category === "bra"
    ) {
      finalSize =
        calculateBraSize();
    }
    else {
      finalSize =
        calculateGeneralSize();
    }
    if (result) {

      result.textContent =
        finalSize;
    }
    saveSize(
      answers.category,
      finalSize
    );
    currentStep =
      visibleSteps.length - 1;
    showStep(currentStep);
  }
  if (retakeBtn) {
    retakeBtn.addEventListener(
      "click",
      function () {

        resetQuiz();

      }
    );

  }
  if (shopBtn) {

    shopBtn.addEventListener(
      "click",
      function () {
        const category =
          answers.category;
        const savedSizes =
          getSavedSizes();
        const size =
          savedSizes[category];
        if (!size) {

          window.location.href =
            "/collections/all";

          return;

        }
        const collectionMap = {

          bra:
            "brallete",

          briefs:
            "briefs",

          lingerie:
            "lingerie",

          shapewear:
            "shapewear",

          nightwear:
            "nightwear",

            exotic: "exotic-wear",
             silk: "silk-dresses"

        };


  const braStyleCollectionMap = {
  everyday: "everyday-bra-sets",
  bralette: "brallete",
  pushup: "push-up-bras",
  wirefree: "starpless-bra"
};

let collection;

if (
  category === "bra" &&
  braStyleCollectionMap[answers.style]
) {
  collection =
    braStyleCollectionMap[answers.style];
} else {
  collection =
    collectionMap[category];
}
        if (collection) {
          window.location.href =
            "/collections/" +
            collection +
            "?filter.v.option.size=" +
            encodeURIComponent(size);

        }
        else {
          window.location.href =
            "/collections/all?filter.v.option.size=" +
            encodeURIComponent(size);

        }
      }
    );

  }


  /* =========================================
     PRODUCT PAGE
     LOAD SAVED SIZE
  ========================================= */

  function loadSavedSize() {

    const category =
      getProductCategory();


    const savedSizes =
      getSavedSizes();


    const savedSize =
      savedSizes[category];


    if (!savedSize) {
      return;
    }


    /*
     * Recommended size box
     */

    const box =
      document.getElementById(
        "thread11-size-box"
      );


    const text =
      document.getElementById(
        "recommended-size-text"
      );


    if (box) {

      box.style.display =
        "block";

    }


    if (text) {

      text.textContent =
        savedSize;

    }


    /*
     * Automatically select
     * Shopify variant.
     */

    setTimeout(
      function () {

        document
          .querySelectorAll("[data-size]")
          .forEach(function (label) {

            const labelSize =
  (
    label.dataset.size ||
    ""
  )
    .trim()
    .toLowerCase();

if (
  labelSize ===
  savedSize
    .trim()
    .toLowerCase()
) {

  label.click();

}

          });

      },
      700
    );

  }


  loadSavedSize();


  /* =========================================
     CHANGE SIZE
  ========================================= */

  const changeSizeLink =
    document.getElementById(
      "change-size-link"
    );


  if (changeSizeLink) {

    changeSizeLink.addEventListener(
      "click",
      function (event) {

        event.preventDefault();

        openModal();

      }
    );

  }


  /* =========================================
     HEADER FIND MY SIZE
  ========================================= */

  document.addEventListener(
    "click",
    function (event) {

      const link =
        event.target.closest(
          'a[href="#find-my-size"]'
        );


      if (!link) {
        return;
      }


      event.preventDefault();

      openModal();

    }
  );

});